import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Menu,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Divider,
  Box,
  Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';
import { useTranslations } from '../../hooks/use-translations';

const ColumnVisibilityMenu = ({ table, columns, buttonProps = {} }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslations();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggleColumn = (columnId) => {
    table.getColumn(columnId)?.toggleVisibility();
  };

  const handleShowAll = () => {
    table.getAllLeafColumns().forEach((column) => {
      if (column.getCanHide()) {
        column.toggleVisibility(true);
      }
    });
  };

  const handleHideAll = () => {
    table.getAllLeafColumns().forEach((column) => {
      if (column.getCanHide()) {
        column.toggleVisibility(false);
      }
    });
  };

  const visibleColumns = table
    .getAllLeafColumns()
    .filter((column) => column.getCanHide());

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Icon icon="mdi:view-column" />}
        onClick={handleClick}
        sx={{ textTransform: 'none', borderRadius: '10px', fontWeight: 400 }}
        {...buttonProps}
      >
        {t('dataGrid.columns')}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            maxHeight: 400,
            width: 250,
          },
        }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary">
            {t('dataGrid.toggleColumns')}
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ px: 1, py: 0.5 }}>
          <Button
            size="small"
            onClick={handleShowAll}
            sx={{ mr: 1, textTransform: 'none' }}
          >
            {t('dataGrid.showAll')}
          </Button>
          <Button
            size="small"
            onClick={handleHideAll}
            sx={{ textTransform: 'none' }}
          >
            {t('dataGrid.hideAll')}
          </Button>
        </Box>
        <Divider />
        {visibleColumns.map((column) => {
          const columnDef = columns.find((col) => col.field === column.id);
          const label = columnDef?.headerName || column.id;
          
          return (
            <MenuItem
              key={column.id}
              dense
              onClick={() => handleToggleColumn(column.id)}
              sx={{ py: 0.5 }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={column.getIsVisible()}
                    size="small"
                  />
                }
                label={label}
                sx={{ width: '100%', m: 0 }}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

ColumnVisibilityMenu.propTypes = {
  table: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  buttonProps: PropTypes.object,
};

export default ColumnVisibilityMenu;


